<template>
    <div style="height: 100%">
        <div style="width: 100%">
            <el-row class="filter-row">
                <el-select size="mini" v-model="formDatas.arfdFrom" clearable @change="partserch"
                    placeholder="请选择扣减渠道" style="width: 150px;">
                    <el-option label="系统" :value="1"></el-option>
                    <el-option label="易宝通" :value="2"></el-option>
                    <el-option label="河北小程序" :value="3"></el-option>
                </el-select>
                <el-input size="mini" v-model="formDatas.phone" clearable placeholder="请输入手机号"
                    style="width: 130px;" @keyup.enter.native="partserch"></el-input>
                <el-input size="mini" v-model="formDatas.uniqueNum" clearable placeholder="请输入唯一凭证"
                    style="width: 160px;" @keyup.enter.native="partserch"></el-input>
                <el-input size="mini" v-model="formDatas.specsSku" clearable placeholder="请输入商品编码"
                    style="width: 130px;" @keyup.enter.native="partserch"></el-input>
                <el-select size="mini" v-model="formDatas.arfdStatus" clearable @change="partserch"
                    placeholder="请选择状态" style="width: 110px;">
                    <el-option label="成功" :value="1"></el-option>
                    <el-option label="失败" :value="2"></el-option>
                </el-select>
                <el-select size="mini" v-model="formDatas.arfdSyncEquityfee" clearable @change="partserch"
                    placeholder="是否同步" style="width: 110px;">
                    <el-option label="否" :value="1"></el-option>
                    <el-option label="是" :value="2"></el-option>
                </el-select>
                <el-select size="mini" v-model="formDatas.acrStatus" clearable @change="partserch"
                    placeholder="请选择券状态" style="width: 130px;">
                    <el-option label="已撤销" :value="0"></el-option>
                    <el-option label="创建" :value="1"></el-option>
                    <el-option label="第三方导入" :value="2"></el-option>
                    <el-option label="第三方领取" :value="3"></el-option>
                    <el-option label="已核销" :value="4"></el-option>
                    <el-option label="已分账" :value="5"></el-option>
                    <el-option label="已退款" :value="6"></el-option>
                </el-select>
                <el-select size="mini" v-model="formDatas.arfdHandlerStatus" clearable @change="partserch"
                    placeholder="处理状态" style="width: 110px;">
                    <el-option label="不需要" :value="0"></el-option>
                    <el-option label="否" :value="1"></el-option>
                    <el-option label="是" :value="2"></el-option>
                    <el-option label="失败" :value="3"></el-option>
                </el-select>
                <el-select size="mini" v-model="formDatas.arfdStatusYd" clearable @change="partserch"
                    placeholder="权益金状态" style="width: 110px;">
                    <el-option label="正常扣减" :value="1"></el-option>
                    <el-option label="已退款" :value="2"></el-option>
                </el-select>
                <el-date-picker size="mini" v-model="formDatas.createTimeStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="交易时间开始" style="width: 180px;" @change="partserch"></el-date-picker>
                <el-date-picker size="mini" v-model="formDatas.createTimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="交易时间结束" style="width: 180px;" @change="partserch"></el-date-picker>
                <el-date-picker size="mini" v-model="formDatas.exchangeTimeStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="核销时间开始" style="width: 180px;" @change="partserch"></el-date-picker>
                <el-date-picker size="mini" v-model="formDatas.exchangeTimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="核销时间结束" style="width: 180px;" @change="partserch"></el-date-picker>
                  <el-input size="mini" v-model="formDatas.orderNum" clearable placeholder="请输入订单号"
                    style="width: 130px;" @keyup.enter.native="partserch"></el-input>    
                <el-button type="info" size="mini" icon="el-icon-search" @click="partserch">搜索</el-button>
                <el-button type="warning" size="mini" icon="el-icon-download" @click="handleExport">导出</el-button>
            </el-row>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>

        <!-- 编辑运营描述弹窗 -->
        <el-dialog title="编辑运营描述" :visible.sync="dialogVisible" width="500px">
            <el-input type="textarea" v-model="operationDes" :rows="4" placeholder="请输入运营描述"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveOperationDes">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjefRightsFundDeductCopyList,
    updateAjefRightsFundDeductCopyHandlerOperation
} from "../../api/api";
export default {
    name: "RightsFundDeductCopy",
    components: {},
    data() {
        return {
            totalCount: 100,
            tableLoading: false,
            tableHight: 520,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "arfdFrom",
                    key: "arfdFrom",
                    title: "扣减渠道",
                    align: "center",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfdFrom == 1 ? '系统' : row.arfdFrom == 2 ? '易宝通' : '河北小程序';
                    },
                },
                {
                    field: "uniqueNum",
                    key: "uniqueNum",
                    title: "唯一凭证",
                    align: "center",
                    width: 180,
                },
                {
                    field: "phone",
                    key: "phone",
                    title: "手机号",
                    align: "center",
                    width: 120,
                },
                {
                    field: "amount",
                    key: "amount",
                    title: "金额(分)",
                    align: "center",
                    width: 90,
                },
                {
                    field: "arfdStatus",
                    key: "arfdStatus",
                    title: "状态",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfdStatus == 1 ? <el-tag type="success">成功</el-tag> : <el-tag type="danger">失败</el-tag>;
                    },
                },
                { field: "specsSku", key: "specsSku", title: "商品编码", width: 130, align: "center" },
                { field: "specsName", key: "specsName", title: "商品名称", width: 130, align: "center" },
                 { field: "createtime", key: "createtime", title: "交易时间", width: 160, align: "center" },
                // {
                //     field: "arfdSyncEquityfee",
                //     key: "arfdSyncEquityfee",
                //     title: "是否同步",
                //     align: "center",
                //     width: 80,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         if (row.arfdSyncEquityfee == 1) return <el-tag type="warning">否</el-tag>;
                //         if (row.arfdSyncEquityfee == 2) return <el-tag type="success">是</el-tag>;
                //         return '-';
                //     },
                // },
                { field: "asNameGet", key: "asNameGet", title: "商户(领取)", width: 180, align: "center" },
                { field: "asName", key: "asName", title: "商户(核销)", width: 180, align: "center" },
                { field: "orderNum", key: "orderNum", title: "订单号", width: 310, align: "center" },
                { field: "orderNumSub", key: "orderNumSub", title: "子订单号", width: 310, align: "center" },
                // { field: "acrId", key: "acrId", title: "券记录ID", width: 100, align: "center" },
                  { field: "createusername", key: "createusername", title: "创建人", width: 100, align: "center" },
                {
                    field: "acrStatus",
                    key: "acrStatus",
                    title: "券状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const statusMap = {
                            0: { text: '已撤销', type: 'info' },
                            1: { text: '创建', type: '' },
                            2: { text: '第三方导入', type: 'warning' },
                            3: { text: '第三方领取', type: 'warning' },
                            4: { text: '已核销', type: 'success' },
                            5: { text: '已分账', type: 'success' },
                             6: { text: '已退款', type: 'danger' }
                        };
                        const status = statusMap[row.acrStatus];
                        return status ? <el-tag type={status.type}>{status.text}</el-tag> : '-';
                    },
                },
                { field: "acrExchangeTime", key: "acrExchangeTime", title: "核销时间", width: 160, align: "center" },
                {
                    field: "arfdStatusYd",
                    key: "arfdStatusYd",
                    title: "权益金状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.arfdStatusYd == 1) return <el-tag type="success">正常扣减</el-tag>;
                        if (row.arfdStatusYd == 2) return <el-tag type="warning">已退款</el-tag>;
                        return '-';
                    },
                },
                {
                    field: "arfdHandlerStatus",
                    key: "arfdHandlerStatus",
                    title: "处理状态",
                    align: "center",
                    fixed: 'right',
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const statusMap = {
                            0: { text: '不需要', type: 'info' },
                            1: { text: '否', type: 'warning' },
                            2: { text: '是', type: 'success' },
                            3: { text: '失败', type: 'danger' }
                        };
                        const status = statusMap[row.arfdHandlerStatus];
                        return status ? <el-tag type={status.type}>{status.text}</el-tag> : '-';
                    },
                },
                { field: "arfdHandlerStatusDes",   fixed: 'right', key: "arfdHandlerStatusDes", title: "处理状态描述", width: 150, align: "center" },
                { field: "arfdHandlerOperation", fixed: 'right', key: "arfdHandlerOperation", title: "运营描述", width: 150, align: "center" },
                {
                    field: "action",
                    key: "action",
                    title: "操作",
                    width: 80,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h('el-button', {
                            props: { type: 'text', size: 'mini' },
                            style: { color: '#409EFF' },
                            on: { click: () => this.handleEditOperation(row) }
                        }, '编辑');
                    },
                },


            ],
            tableData: [],
            dialogVisible: false,
            editRow: null,
            operationDes: '',
            formDatas: {
                arfdStatus:1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = val - 200 - val * 0.04;
            });
        },
    },
    deactivated() {},
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    mounted() {},
    methods: {
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleExport() {
            var s = qs.stringify(this.formDatas);
            this.openLoading();
            var that = this;
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-rights-fund-deduct-copy/exportAjefRightsFundDeductCopy',
                data: s,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close();
                    let a = document.createElement('a');
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '订单记录.xlsx');
                    a.click();
                    that.$message({
                        message: "导出成功",
                        type: "success"
                    });
                }
            }).catch(() => {
                that.loadings.close();
            });
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefRightsFundDeductCopyList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefRightsFundDeductCopyList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefRightsFundDeductCopyList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        handleEditOperation(row) {
            this.editRow = row;
            this.operationDes = row.arfdHandlerOperation || '';
            this.dialogVisible = true;
        },
        saveOperationDes() {
            if (!this.editRow) return;
            updateAjefRightsFundDeductCopyHandlerOperation({
                arfdId: this.editRow.arfdId,
                arfdHandlerOperation: this.operationDes
            }).then(() => {
                this.$message.success('保存成功');
                this.dialogVisible = false;
                this.getList();
            }).catch(() => {
                this.$message.error('保存失败');
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.filter-row {
    margin:0 10px;
    width: 98%;
    display: flex;
    padding-left: 20px;
    flex-wrap: wrap;
}

.filter-row > * {
    margin-top: 5px;
    margin-left: 10px;
}

.filter-row > *:first-child {
    margin-left: 0;
}
</style>
